/* Built In Imports */
import dynamic from 'next/dynamic';

/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@msr//Utility/StructuredTextParser';
import SectionTitle from '@msr/components/Headings/MsrSectionTitle';

/* Services */

/**
 *
 * @param root0
 * @param root0.section
 * @param root0.lang
 * @returns
 */
export const ProgramLocationDetails = ({ section, lang }) => {
  const GoogleMap = dynamic(() => import('@components/Embeds/GoogleMap'));

  return (
    <Box
      bgColor={'#DFCCA8'}
      color="#fff"
      maxW="1140px"
      width="full"
      display="flex"
      mx="auto"
      justifyContent="space-between"
      flexDir="column"
      pb={{ base: '40px', lg: '90px' }}
      pt={{ base: '20px', lg: '35px' }}

    >
      <SectionTitle w={{base:'250px', md: '408px'}} titleObj={section?.sectionContent[0]} />

      <Box
        justifyContent="center"
        // gridGap={{ base: '15px', lg: '40px' }}
        display="flex"
        flexDir={{ base: 'column', lg: 'row' }}
        bgColor={'#10143B'}
        maxH={{ base: 'auto', lg: '480px' }}
        mt={'30px'}
        mx={'1rem'}
        flexDirection={'column-reverse'}
      >
        <Box w={{ base: '100%', lg: "50%" }}
          px={{ base: '25px', lg: '0px' }}
          pt={{ base: '15px', lg: '0px' }}
          pb={{ base: '25px', lg: '0px' }}>
          <StructuredTextParser
            id={'program_location_details'}
            str={render(section.sectionContent[1]?.body)}
            mt={{base:'0px', lg: '32px'}}
            bgTheme="light"
            fontWeight="400"
            fontSize="16px"
            lang={lang}
            lineHeight={"32px"}
            fontFamily={'FedraSansStd-book'}
            color={"#fff"}
            w={{ base: '100%', lg: '477px' }}
          />
          {/* <StructuredTextParser
            str={render(section.sectionContent[2]?.body)}
            mt="-20px"
            bgTheme="light"
            fontWeight="bold"
            fontSize="18px"
            lang={lang}
          />

          <Box mt="30px">
            <StructuredTextParser
              str={render(section.sectionContent[3]?.body)}
              fontSize={{ base: '26px', lg: '40px' }}
              bgTheme="light"
              color="#FFA735"
              lang={lang}
            />
            <StructuredTextParser
              str={render(section.sectionContent[4]?.body)}
              mt="0"
              fontSize={{ base: '26px', lg: '40px' }}
              bgTheme="light"
              tAlign="left"
              lang={lang}
            />
          </Box> */}
        </Box>
        <Box w={{ base: '100%', lg: "50%" }}>
          <GoogleMap maxW={'100%'} width={'100%'} mht={'220px'} ht={'480px'} my={"0px"} sectionContent={section.sectionContent[2]} />
        </Box>
      </Box>
      <style>
        {
        `#program_location_details strong {
          color: #FFE7CC;
          font-weight: 450;
        }
        #program_location_details ul li p {
          font-size: 16px !important;
          line-height: 32px !important;
        }
        `}
      </style>
    </Box>
  );
};
